import produce from 'immer';
import {
    ACTION_SEND_TAN,
    ACTION_LOGIN,
    ACTION_SET_MTAN_STEP,
    ACTION_SET_ERROR,
    ACTION_SEND_TAN_SUCCESS,
    ACTION_SET_IS_LOGGED_IN,
    ACTION_INIT_PAGE,
    ACTION_INIT_PAGE_SUCCESS,
    ACTION_ADD_COMPONENTS,
} from './constant';
import { IAuthentication } from './interfaces/main.interface';
import { AppAction } from './action';

/**
 * Export initalState
 */
export const initialState: IAuthentication = {
    mtanStep: null,
    loading: false,
    isUserLoggedIn: false,
    error: null,
    components: null,
};

const authenticationReducer = (state = initialState, action: AppAction) =>
    produce(state, draft => {
        switch (action.type) {
            case ACTION_LOGIN:
            case ACTION_SEND_TAN:
                draft.loading = true;
                break;
            case ACTION_SET_ERROR: {
                draft.error = action.error;
                draft.loading = false;
                break;
            }
            case ACTION_SEND_TAN_SUCCESS:
            case ACTION_INIT_PAGE_SUCCESS:
                draft.loading = false;
                break;
            case ACTION_SET_MTAN_STEP:
                draft.mtanStep = action.mtanStep;
                break;
            case ACTION_SET_IS_LOGGED_IN:
                draft.isUserLoggedIn = action.isUserLoggedIn;
                break;
            case ACTION_ADD_COMPONENTS:
                draft.components = action.components;
                break;
            case ACTION_INIT_PAGE:
                draft.mtanStep = initialState.mtanStep;
                draft.isUserLoggedIn = initialState.isUserLoggedIn;
                draft.error = initialState.error;
                draft.components = initialState.components;
                draft.loading = true;
        }
    });

export default authenticationReducer;
